// material
import {
  Box,
  Backdrop,
  Container,
  Typography,
  Card,
  Stack,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getSettings, setChoicePlayer, settingsSelector } from '../slices/settingsSlice';
// components
import Page from '../components/Page';
import { ApiStatus } from '../utils/constants';
// ----------------------------------------------------------------------

export default function DashboardApp() {
  const { settings, status, errorMessage } = useSelector(settingsSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  return (
    <Page title="Dashboard">
      <Backdrop style={{ zIndex: 100, color: '#fff' }} open={status === ApiStatus.loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Hi, Welcome back</Typography>
        </Box>
      </Container>
      {errorMessage.length > 0 && <Alert variant="error">{errorMessage}</Alert>}
      <Card style={{ padding: '20px' }}>
        <img
          alt=""
          src={`${process.env.REACT_APP_IMAGE_URL}${
            settings.choiceplayer
          }? ${new Date().getTime()}`}
        />
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Button variant="contained" component="label">
            Change Default Player Image
            <input
              type="file"
              name="image"
              hidden
              onChange={(event) => {
                event.stopPropagation();
                if (event.target.files) {
                  const file = event.target.files[0];
                  const formData = new FormData();
                  formData.append('image', file);
                  dispatch(setChoicePlayer(formData));
                }
              }}
            />
          </Button>
        </Stack>
      </Card>
    </Page>
  );
}
